import { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Col, Row } from 'reactstrap'
import TableColumnPreferenceControl from '../../Material/TableColumnPreferenceControl'
import { HasPermissionsQuery } from "../../Functions/querys"
import CreateUpdateTPAAdjusterModal from './CreateUpdateTPAAdjusterModal'

class TPAAdjustersAction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="text-right mt-3">
                    <TableColumnPreferenceControl
                        tableId={this.props.tableId}
                        columnConfig={this.props.columnConfig}
                        setColumnConfig={this.props.setColumnConfig}
                        defaultColumnConfig={this.props.defaultColumnConfig}
                    />&nbsp;&nbsp;&nbsp;
                    {this.props.hasPermissions && this.props.hasPermissions.includes("add_tpaadjuster") && (
                        <>
                            <a id="createNewTpaAdjuster" className="driver-list-button" onClick={() => this.toggleModal("createNewTpaAdjuster")}>
                                CREATE | <i className="fa fa-plus" aria-hidden="true"></i>
                            </a>&nbsp;&nbsp;&nbsp;
                        </>
                    )}
                    {this.state.openModal === "createNewTpaAdjuster" &&
                        <CreateUpdateTPAAdjusterModal
                            isOpen={this.state.openModal === "createNewTpaAdjuster"}
                            toggle={() => this.toggleModal("")}
                            refetchQuery={this.props.refetchQuery}
                        />}
                </Col>
            </Row>
        )
    }
}

export default graphql(
    HasPermissionsQuery, {
    options: () => ({
        variables: { userPermissions: ["add_tpaadjuster"] },
    }),
    props: ({ data: { hasPermissions } }) => ({
        hasPermissions,
    })
}
)(TPAAdjustersAction)
